import React, { ReactElement } from "react";
import { ReactComponent as FileBlue } from "../../../images/file_blue.svg";
import { ReactComponent as FilePurplePending } from "../../../images/file_purple_pending.svg";
import { ReactComponent as FileGreenCheck } from "../../../images/file_green_check.svg";
import { ReactComponent as CheckBlueCircle } from "../../../images/check_blue_circle.svg";
import { ReactComponent as CalendarDotsBlue } from "../../../images/calendar-dots_blue.svg";
import { ReactComponent as ExclamationTriangleRed } from "../../../images/exclamation-triangle_red.svg";
import { ReactComponent as ClockYellow } from "../../../images/clock_yellow.svg";
import { HeadingTypeTileContent } from "./tile-contents/headingTypeTileContent";
import { InfoTypeTileContent } from "./tile-contents/infoTypeTileContent";
import { ProgressTypeTileContent } from "./tile-contents/progressTypeTileContent";
import { ShipmentReconciliationSummaryTileTypes, ShipmentReconciliationSummaryTypes } from "../../../app/data/shipment-reconciliation/models";
import "./shipmentReconciliationSummaryTile.scss";

interface ShipmentReconciliationSummaryTileProps {
    tileContentType: ShipmentReconciliationSummaryTileTypes,
    type: ShipmentReconciliationSummaryTypes;
    isLoading: boolean;
    title: string;
    value: string | number | ReactElement;
    legendDescription: string;
    onApply?: any;
    totalValue?: number;
    
}

const getTileIcon = (type: ShipmentReconciliationSummaryTypes) => {
    if (type === ShipmentReconciliationSummaryTypes.TOTAL_SHIPMENTS) return <FileBlue />;
    else if ( type === ShipmentReconciliationSummaryTypes.PENDING_FOR_REVIEW) return <FilePurplePending />;
    else if ( type === ShipmentReconciliationSummaryTypes.REVIEWED) return <FileGreenCheck />;
    else if ( type === ShipmentReconciliationSummaryTypes.REVIEW_PROGRESS) return <CheckBlueCircle />; 
    else if ( type === ShipmentReconciliationSummaryTypes.ACCEPTED) return <FileGreenCheck />;
    else if ( type === ShipmentReconciliationSummaryTypes.REJECTED) return <ExclamationTriangleRed />;
    else if ( type === ShipmentReconciliationSummaryTypes.APPROVAL_RATE) return <CheckBlueCircle />; 
    else if ( type === ShipmentReconciliationSummaryTypes.REVIEW_DAYS) return <CalendarDotsBlue />; 
    else if ( type === ShipmentReconciliationSummaryTypes.FINDINGS) return <FileGreenCheck />; 
    else if ( type === ShipmentReconciliationSummaryTypes.REVENUE) return <FileGreenCheck />; 
    else if ( type === ShipmentReconciliationSummaryTypes.AVERAGE) return <ClockYellow />; 
    else return <></>;  
}


export const ShipmentReconciliationSummaryTile: React.FC<ShipmentReconciliationSummaryTileProps> = (props) => {

    const getContentByTileType = () => {
        if (props.tileContentType === "HEADING") {
            return <HeadingTypeTileContent
                isLoading={props.isLoading}
                title={props.title}
                value={props.value}
                legendDescription={props.legendDescription}
                onApply={props.onApply}
            />;
        } else if (props.tileContentType === "INFO") {
            return <InfoTypeTileContent
                isLoading={props.isLoading}
                title={props.title}
                value={props.value}
                legendDescription={props.legendDescription}
                onApply={props.onApply}
            />;
        } else if (props.tileContentType === "PROGRESS") {
            return <ProgressTypeTileContent
                isLoading={props.isLoading}
                title={props.title}
                value={(props.value && +props.value) ? +props.value : 0}
                totalValue={(props.totalValue && +props.totalValue) ? +props.totalValue : 0}
            />
        }

    }
    return (<div className="xgs-shipment-reconciliation-summary-tile">
        <div className={`xgs-shipment-reconciliation-summary-tile__icon-container --type-${props.type}`}>
            {getTileIcon(props.type)}
        </div>
        {getContentByTileType()}
    </div>
    )
};